// https://github.com/auth0-blog/vue-jwt-authentication/blob/master/src/auth/index.js
import httpClient from 'api'

const TOKEN = 'id_token'
const PASSWORD_UPDATED = 'password_updated'
const PROFILE_UPDATED = 'profile_updated'
const LECTURER_NO = 'lecturer_no'

const getToken = () => {
  return localStorage.getItem(TOKEN)
}
const storeLecturerAuthToken = (t) => {
  localStorage.setItem(TOKEN, t.token)
  localStorage.setItem(LECTURER_NO, t.lecturer_no)
  localStorage.setItem(PASSWORD_UPDATED, t.password_updated ? 'updated' : '')
  localStorage.setItem(PROFILE_UPDATED, t.profile_updated ? 'updated' : '')
}
const removeAllItems = () => {
  [TOKEN, LECTURER_NO, PASSWORD_UPDATED, PROFILE_UPDATED].forEach(k => {
    localStorage.removeItem(k)
  })
}

export default {
  login (context, creds) {
    return httpClient.login(context, creds).then(response => {
      storeLecturerAuthToken(response.body)
      return response.body
    })
  },

  logout () {
    removeAllItems()
  },

  isAuthenticated () {
    return !!getToken()
  },

  isPasswordUpdated () {
    return !!localStorage.getItem(PASSWORD_UPDATED)
  },
  updatePassword () {
    localStorage.setItem(PASSWORD_UPDATED, 'updated')
  },
  isProfileUpdated () {
    return !!localStorage.getItem(PROFILE_UPDATED)
  },
  updateProfile () {
    localStorage.setItem(PROFILE_UPDATED, 'updated')
  },
  getLecturerNo () {
    return localStorage.getItem(LECTURER_NO)
  },

  getAuthHeader () {
    return {
      'Authorization': 'Bearer ' + getToken()
    }
  }
}



// WEBPACK FOOTER //
// ./src/auth/index.js